type TransitionController = {
  getDocumentTransitions: () => Promise<string[]>;
  performDocumentTransition: (transition: string) => Promise<string>;
  navigateToPlaceInWorkflow: (place: string) => void;
};

export const performDesiredTransition = async (
  controller: TransitionController,
  desiredTransitionPriority?: string[],
): Promise<void> => {
  const enabledTransitions = await controller.getDocumentTransitions();

  const transition = (desiredTransitionPriority ?? enabledTransitions).find(
    (t) => enabledTransitions.includes(t),
  );

  if (transition) {
    const newPlace = await controller.performDocumentTransition(transition);
    controller.navigateToPlaceInWorkflow(newPlace);
  }
};
